import { defineSlotRecipe as e } from "@pandacss/dev";
import { anatomy as t } from "../../node_modules/@ark-ui/anatomy/node_modules/@zag-js/pagination/dist/index.mjs";
const a = e({
  className: "pagination",
  slots: [...t.keys(), "chevron"],
  base: {
    root: {
      display: "flex",
      gap: "2"
    },
    item: {
      fontVariantNumeric: "tabular-nums",
      fontSize: "md",
      py: "1",
      px: "3"
    },
    ellipsis: {
      alignItems: "center",
      color: "fg.default",
      display: "inline-flex",
      fontWeight: "semibold",
      px: "2"
    },
    chevron: {
      width: "32px",
      height: "32px",
      background: "fg-white",
      color: "text-tertiary",
      borderRadius: "50%"
    }
  }
});
export {
  a as pagination
};
